import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios';

import {
  requestBearerTokenInterceptor,
} from './interceptors';

export let httpClient: AxiosInstance = axios;

export function createHttpClient(defaults: CreateAxiosDefaults) {
  httpClient = axios.create(defaults);

  const requestBearerTokenInterceptorId = httpClient.interceptors.request.use(requestBearerTokenInterceptor);

  return {
    requestBearerTokenInterceptorId,
  };
}
